// src/hooks/useFirestore.js
// Custom hook: بيرجع بيانات collection معينة لحظيًا (real-time) من Firestore

import { useEffect, useState } from 'react';
import { subscribeToCollection } from '../firebase/firestore';

export default function useFirestore(collectionName, sortField = 'createdAt') {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    const unsubscribe = subscribeToCollection(
      collectionName,
      (items, err) => {
        setData(items);
        setError(err);
        setLoading(false);
      },
      sortField
    );
    return unsubscribe;
  }, [collectionName, sortField]);

  return { data, loading, error };
}
